module.exports = __webpack_public_path__ + "img/Glider.e209ef22.jpg";